import React, { Component } from "react";
import { CallAPI, GetCookieFunction } from '../../utils/util';
import Alert from 'react-bootstrap/Alert';

class Scheduling extends Component {
    constructor(props) {
        super(props);
        this.centerId = GetCookieFunction("Center").id;
        this.state = {
            slots: [],
            newStartTime: "",
            newEndTime: "",
            modalVariant: "",
            modalMessage: "",
            confirmDeleteSlotId: null,
            deleteConfirmText: '',
            deleteConfirmError: '',
            loading: true
        };
    }

    componentDidMount() {
        this.loadSlots();
    }

    loadSlots = () => {
        CallAPI({}, `scheduling/slots?centerId=${this.centerId}`, 'GET', (res) => {
            if (res.success) {
                this.setState({ slots: res.data, loading: false });
            }
        }, () => {
            this.setState({ loading: false, modalVariant: "danger", modalMessage: "Failed to load slots" });
        });
    }

    handleAddSlot = (e) => {
        e.preventDefault();
        const { newStartTime, newEndTime } = this.state;

        if (!newStartTime || !newEndTime) {
            this.setState({ modalVariant: "danger", modalMessage: "Start and end time are required" });
            return;
        }

        CallAPI({ startTime: newStartTime, endTime: newEndTime, centerId: this.centerId }, 'scheduling/slots', 'POST', (res) => {
            if (res.success) {
                this.setState({ newStartTime: "", newEndTime: "", modalVariant: "success", modalMessage: "Slot added" });
                this.loadSlots();
            } else {
                this.setState({ modalVariant: "danger", modalMessage: res.message || "Failed to add slot" });
            }
        }, (err) => {
            this.setState({ modalVariant: "danger", modalMessage: err.message || "Failed to add slot" });
        });
    }

    handleDeleteSlot = (slotId) => {
        this.setState({ confirmDeleteSlotId: slotId });
    }

    confirmDelete = () => {
        if (this.state.deleteConfirmText.toLowerCase() !== 'delete') {
            this.setState({ deleteConfirmError: 'Type "delete" to confirm' });
            return;
        }

        const slotId = this.state.confirmDeleteSlotId;
        this.setState({ confirmDeleteSlotId: null, deleteConfirmText: '', deleteConfirmError: '' });

        CallAPI({}, `scheduling/slots/${slotId}?centerId=${this.centerId}`, 'DELETE', (res) => {
            if (res.success) {
                this.setState({ modalVariant: "success", modalMessage: "Slot removed" });
                this.loadSlots();
            } else {
                this.setState({ modalVariant: "danger", modalMessage: res.message || "Cannot remove slot" });
            }
        }, (err) => {
            this.setState({ modalVariant: "danger", modalMessage: err.message || "Failed to remove slot" });
        });
    }

    formatTime = (timeStr) => {
        if (!timeStr) return "";
        const [h, m] = timeStr.split(":");
        const hour = parseInt(h, 10);
        const ampm = hour >= 12 ? "PM" : "AM";
        const h12 = hour % 12 || 12;
        return `${h12}:${m} ${ampm}`;
    }

    generateTimeOptions = () => {
        const options = [];
        for (let h = 7; h <= 23; h++) {
            for (let m = 0; m < 60; m += 30) {
                const val = `${String(h).padStart(2, '0')}:${String(m).padStart(2, '0')}`;
                const hour = h % 12 || 12;
                const ampm = h >= 12 ? 'PM' : 'AM';
                const label = `${hour}:${String(m).padStart(2, '0')} ${ampm}`;
                options.push(<option key={val} value={val}>{label}</option>);
            }
        }
        return options;
    }

    render() {
        if (this.state.loading) {
            return <div className="ci-page"><div className="ci-header"><h2>Loading...</h2></div></div>;
        }

        const timeOptions = this.generateTimeOptions();

        return (
            <div className="ci-page">
                <div className="ci-header">
                    <h2>Scheduling Configuration</h2>
                    <p>Manage time slots for dialysis sessions at your center</p>
                </div>

                {this.state.modalVariant && (
                    <Alert variant={this.state.modalVariant} className="ci-alert"
                        dismissible onClose={() => this.setState({ modalVariant: "", modalMessage: "" })}>
                        {this.state.modalMessage}
                    </Alert>
                )}

                <div className="ci-section-title">Time Slots</div>
                <div className="ci-card">
                    {this.state.slots.length === 0 ? (
                        <p style={{color: 'var(--text-muted)', fontSize: '14px'}}>No time slots configured. Add your first slot below.</p>
                    ) : (
                        <div className="editable-table-wrap">
                            <div className="editable-table-header">
                                <div className="editable-col-main">Start Time</div>
                                <div className="editable-col-main">End Time</div>
                                <div className="editable-col-action"></div>
                            </div>
                            {this.state.slots.map((slot) => (
                                <div key={slot.slotId} className="editable-table-row">
                                    <div className="editable-col-main" style={{fontWeight: 600}}>
                                        {this.formatTime(slot.startTime)}
                                    </div>
                                    <div className="editable-col-main" style={{fontWeight: 600}}>
                                        {this.formatTime(slot.endTime)}
                                    </div>
                                    <div className="editable-col-action">
                                        <button type="button" className="editable-delete-btn"
                                            onClick={() => this.handleDeleteSlot(slot.slotId)}
                                            aria-label="Remove slot">✕</button>
                                    </div>
                                </div>
                            ))}
                        </div>
                    )}
                </div>

                <div className="ci-section-title">Add New Slot</div>
                <div className="ci-card">
                    <form onSubmit={this.handleAddSlot}>
                        <div className="ci-grid">
                            <div className="ci-field">
                                <label htmlFor="newStartTime">Start Time</label>
                                <select id="newStartTime" required
                                    value={this.state.newStartTime}
                                    onChange={(e) => this.setState({ newStartTime: e.target.value })}>
                                    <option value="">-- Select --</option>
                                    {timeOptions}
                                </select>
                            </div>
                            <div className="ci-field">
                                <label htmlFor="newEndTime">End Time</label>
                                <select id="newEndTime" required
                                    value={this.state.newEndTime}
                                    onChange={(e) => this.setState({ newEndTime: e.target.value })}>
                                    <option value="">-- Select --</option>
                                    {timeOptions}
                                </select>
                            </div>
                            <div className="ci-field" style={{justifyContent: 'flex-end'}}>
                                <button type="submit" className="logSubmit" style={{width: 'auto', marginTop: 0}}>Add Slot</button>
                            </div>
                        </div>
                    </form>
                </div>

                {/* Confirmation Modal */}
                {this.state.confirmDeleteSlotId && (
                    <div className="ci-modal-overlay" onClick={() => this.setState({ confirmDeleteSlotId: null, deleteConfirmText: '', deleteConfirmError: '' })}>
                        <div className="ci-modal" onClick={(e) => e.stopPropagation()}>
                            <h3>Delete Time Slot</h3>
                            <p style={{fontSize: '14px', color: 'var(--text-secondary)', margin: '12px 0'}}>
                                Are you sure you want to delete this time slot? This will affect all appointments currently scheduled in this slot.
                            </p>
                            <div className="ci-field" style={{marginBottom: '12px'}}>
                                <label>Type <b>delete</b> to confirm</label>
                                <input type="text" placeholder="delete"
                                    value={this.state.deleteConfirmText}
                                    onChange={(e) => this.setState({ deleteConfirmText: e.target.value, deleteConfirmError: '' })} />
                                {this.state.deleteConfirmError && (
                                    <span style={{color: 'var(--danger)', fontSize: '12px', marginTop: '4px'}}>{this.state.deleteConfirmError}</span>
                                )}
                            </div>
                            <div className="ci-submit-row">
                                <button type="button" className="homeButton" onClick={() => this.setState({ confirmDeleteSlotId: null, deleteConfirmText: '', deleteConfirmError: '' })}>Cancel</button>
                                <button type="button" className="logSubmit" style={{width: 'auto', background: 'var(--danger)'}} onClick={this.confirmDelete}>Delete Slot</button>
                            </div>
                        </div>
                    </div>
                )}
            </div>
        );
    }
}

export default Scheduling;
